/* eslint-disable no-use-before-define */

const keysToDelete = [
  'access_token',
  'expires_in',
  'headers',
  'idToken',
  'idTokens',
  'issued_tokens',
  'maskedValidationChannel',
  'profiles',
  'subjects',
  'token_type'
];

const isObject = obj => !Array.isArray(obj) && obj === Object(obj);

/**
 * Cleans array object of keys keys listed in keysToDelete array
 * @param {Array} arry
 * @returns {Array}
 */
const cleanArray = arry => {
  arry = arry.map(obj => {
    if (isObject(obj)) {
      return cleanObject(obj);
    } else if (Array.isArray(obj)) {
      return cleanArray(obj);
    }

    return obj;
  });

  return arry;
};

/**
 * Cleans object of keys keys listed in keysToDelete array
 * @param {object} obj
 * @returns {object}
 */
const cleanObject = (obj = {}) => {
  const retObj = {};
  for (const [key, value] of Object.entries(obj)) {
    if (!keysToDelete.includes(key)) {
      if (isObject(value)) {
        retObj[key] = cleanObject(value);
      } else if (Array.isArray(value)) {
        retObj[key] = cleanArray(value);
      } else {
        retObj[key] = value;
      }
    }
  }

  return retObj;
};

/**
 * Returns cloned object with the keys listed in keysToDelete array removed to prevent
 * them from being logged
 * @param {object} data
 * @returns {object}
 */
const scrubLogs = (data = {}) => {
  const dataClone = {};

  for (const [key, value] of Object.entries(data)) {
    if (!keysToDelete.includes(key)) {
      if (isObject(value)) {
        dataClone[key] = cleanObject(value);
      } else if (Array.isArray(value)) {
        dataClone[key] = cleanArray(value);
      } else {
        dataClone[key] = value;
      }
    }
  }

  return dataClone;
};

export default scrubLogs;
